import React, { Component, type ErrorInfo, type ReactNode } from 'react';
import ComercialManagement from '@crm/components/Comercial/ComercialManagement';
import '@crm/components/Comercial/ComercialManagement.css';

export type CccGestaoModalKind = 'minhas-propostas' | 'meus-contratos';

type Props = {
  modal: CccGestaoModalKind;
  filterUserId?: number | null;
  filterUserLabel?: string;
  /** Load proposals/contracts from CCC Recuperação gestão API (claimed clients only). */
  gestaoCccRecuperacao?: boolean;
  onClose: () => void;
};

type ErrorBoundaryState = { error: Error | null };

class GestaoModalsErrorBoundary extends Component<
  { children: ReactNode; onClose: () => void },
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[CccGestaoModalsOverlay] render failed', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="rec-gestao-modals-overlay" role="dialog" aria-modal="true">
          <div className="rec-gestao-modals-error">
            <p>Não foi possível abrir este painel.</p>
            <button type="button" className="rec-btn rec-btn-primary" onClick={this.props.onClose}>
              Fechar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

/** Host Minhas Propostas / Meus Contratos from CCC without mounting the full Gestão board. */
const CccGestaoModalsOverlay: React.FC<Props> = ({
  modal,
  filterUserId = null,
  filterUserLabel,
  gestaoCccRecuperacao = false,
  onClose,
}) => (
  <div className="rec-gestao-modals-overlay gestao-marcacoes" role="presentation">
    <GestaoModalsErrorBoundary onClose={onClose}>
      <ComercialManagement
        gestaoModalsOnly
        gestaoCccRecuperacao={gestaoCccRecuperacao}
        autoOpenModal={modal}
        gestaoFilterUserId={filterUserId}
        gestaoFilterUserLabel={filterUserLabel}
        onGestaoModalsClose={onClose}
      />
    </GestaoModalsErrorBoundary>
  </div>
);

export default CccGestaoModalsOverlay;
